import { UserAction } from 'modules/application/misc/UndoRedoService';
export class AddStateIAction extends UserAction {
    static $inject = ['properties'];
    constructor(properties) {
        super();
        Object.assign(this, properties);
    }
}
